import {
  CreateStandardFinding,
  StandardFinding,
  StandardFindingId,
  UpdateStandardFinding,
} from "platformed-client/types";
import {platformedClient} from "..";
import {invalidateQueries, q} from "../../state";

export async function list(): Promise<StandardFinding[]> {
  return platformedClient.internalRequest("get", "/region/{region}/api/tprm/standard_findings", {});
}

export async function create(standardFindings: CreateStandardFinding[]): Promise<string> {
  const res = await platformedClient.internalRequest("post", "/region/{region}/api/tprm/standard_findings", {
    body: standardFindings,
  });

  await invalidateQueries([q.tprm.standardFindings.filter()]);

  return res;
}

export async function update(standardFindingId: StandardFindingId, update: UpdateStandardFinding): Promise<string> {
  const res = await platformedClient.internalRequest(
    "patch",
    "/region/{region}/api/tprm/standard_findings/{standard_finding_id}",
    {path: {standard_finding_id: standardFindingId}, body: update},
  );

  await invalidateQueries([q.tprm.standardFindings.filter()]);

  return res;
}

export async function delete_(standardFindingId: StandardFindingId): Promise<void> {
  await platformedClient.internalRequest(
    "delete",
    "/region/{region}/api/tprm/standard_findings/{standard_finding_id}",
    {path: {standard_finding_id: standardFindingId}},
  );

  await invalidateQueries([q.tprm.standardFindings.filter()]);
}
